import { useMemo, useEffect, useState } from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DataTable from "examples/Tables/DataTable";
import { useTranslation } from 'react-i18next';
import { Divider } from "@mui/material";
import Utility from "../utility/utility";

function BhavaAspects({ tableData }) {
    const { t } = useTranslation();

    const dataTableData = {
        columns: [
            { Header: t("Bhavaya"), accessor: "bhavaIndex" },
            { Header: t("Nekatha"), accessor: "nekatha" },
            { Header: t("UpaGraha"), accessor: "upaGraha" },
            { Header: t("BhavaAspectsCol5"), accessor: "gahasInBhava" },
            //ලැගුම්ගෙන සිටි  ග්‍රහයෝ
            { Header: t("BhavaAspectsCol4"), accessor: "bnL1" },
            //ලැගුම්ගත්තන්ගේ නැකත්වල  තැන්පත්  ග්‍රහයින්  
            { Header: t("BhavaAspectsCol7"), accessor: "bnL4" },
            //අධිපති
            { Header: t("BhavaAspectsCol6"), accessor: "bnL3" },
            //අධිපතිගේ නැකත්වල  තැන්පත්  ග්‍රහයින් 

        ],
        rows: tableData
    }

    return (
        <MDBox pt={0} pb={1} id="planets-ref">
            <MDBox mb={1}>
                <Card>
                    {/* <MDBox p={3} lineHeight={1} mb={0} display="flex" alignItems="center">
                        <MDTypography variant="h5" fontWeight="medium">
                            ග්‍රහස්ථුට
                        </MDTypography>
                        <Divider variant="fullWidth" sx={{ flexGrow: 1, marginLeft: 2 }} />
                    </MDBox> */}
                    <DataTable
                        canSearch={false}
                        entriesPerPage={false}
                        showTotalEntries={false}
                        table={dataTableData} />
                </Card>
            </MDBox>
        </MDBox>
    );
};

BhavaAspects.propTypes = {
    tableData: PropTypes.any
};

export default BhavaAspects;